module.exports = __webpack_public_path__ + "static/media/market_trgt.02447459.png";